import React, { useState } from "react";
import GlobalContext from "./globalContext";
import useLoginGigya from "../shared/hooks/useLoginGigya";

interface Props {
  children: React.ReactNode;
}

const GlobalProvider = ({ children }: Props) => {
  const [superFooter, setSuperFooter] = useState(false);
  const [genreSelected, setGenreSelected] = useState("");
  const [gigyaUid, setGigyaUid] = useState("");
  const {
    login,
    loginComfamaId,
    logout,
    register,
    updateProfile,
    showScreen,
    updateProfilePhoto,
    gigyaAccount,
    isLoadingGigya,
  } = useLoginGigya();

  return (
    <GlobalContext.Provider
      value={{
        superFooter: { get: superFooter, set: setSuperFooter },
        genreSelected: { get: genreSelected, set: setGenreSelected },
        gigyaUid: { get: gigyaUid, set: setGigyaUid },
        gigyaContext: {
          login,
          loginComfamaId,
          logout,
          register,
          updateProfile,
          showScreen,
          updateProfilePhoto,
          gigyaAccount,
          isLoadingGigya,
        },
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalProvider;
